import { createFeatureSelector, createSelector } from '@ngrx/store'
import { GEOLOCATION_FEATURE_KEY, GeolocationState } from './geolocation.reducer'

export const selectGeolocationState = createFeatureSelector<GeolocationState>(GEOLOCATION_FEATURE_KEY)

export const selectGeolocation = createSelector(selectGeolocationState, (state: GeolocationState) => state)

export const selectGeolocationLoaded = createSelector(selectGeolocationState, (state: GeolocationState) => state.loaded)
